import type { ApiHelpers } from '@thecompaniesapi/api-helpers'

export default function useApi() {
  const nuxtApp = useNuxtApp()

  return nuxtApp.$api as ApiHelpers
}
